module.exports = __webpack_public_path__ + "assets/img/img.80997b79.png";